var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtnArrowBackActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2947 19.2947C11.6842 19.6842 12.3158 19.6842 12.7053 19.2947V19.2947C13.0946 18.9054 13.0949 18.2743 12.7059 17.8847L7.83 13L19 13C19.5523 13 20 12.5523 20 12V12C20 11.4477 19.5523 11 19 11L7.83 11L12.7059 6.11531C13.0949 5.72568 13.0946 5.0946 12.7053 4.70531V4.70531C12.3158 4.31578 11.6842 4.31578 11.2947 4.70531L4.70711 11.2929C4.31658 11.6834 4.31658 12.3166 4.70711 12.7071L11.2947 19.2947Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnArrowBackActive);
export default __webpack_public_path__ + "static/media/btn-arrow-back-active.e7584e22a2e08a8408192fa7d430b72f.svg";
export { ForwardRef as ReactComponent };